<template>
  <form id="hotelApprovalForm" action="/api/update_request/hotel" method="POST" class="text-left text-sm">
    <div class="form-row" v-if="!readonly">
      <div class="col-12">
        <div class="text-lg mb-2">
          Pending hotel approval:
          <ul>
            <li v-for="(request_data, key) in update_requests" :key="key">
              <span v-if="request_data.source"
                >from Placement:
                <a :href="`/placement/edit/${request_data.source.id}`" target="_blank">
                  {{ request_data.source.policyholder.name }}
                </a>
                <br />
              </span>
              made by: {{ request_data.changed_by }} on
              {{ formatDate(request_data.updated_at) }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-sm-12">
        <h5 class="font-weight-bold bg-light p-2 mb-3 border-bottom text-xl">Hotel Info <sup v-if="isNew" class="text-danger">(NEW!)</sup></h5>
      </div>
    </div>

    <div class="form-row">
      <div class="col-sm-6 col-md-3">
        <div class="form-group" v-if="field_update_options['name'] && field_update_options['name'].length">
          <div class="tooltip-v2">
            <div v-if="(data.name || update_data.name) && data.name != update_data.name">
              <div class="tooltip-v2-text left" v-html="data.name ? data.name : 'Not filled yet'"></div>
              <label class="form-control-wrap">
                Name <span style="color: #ff1d25;">*</span> <span class="d-inline text-success visible">*</span>
              </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Name <span style="color: #ff1d25;">*</span></label>
            </div>

            <v-select v-model="update_data.name" class="form-control" name="name" :options="field_update_options['name']"></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Name <span style="color: #ff1d25;">*</span></label>
          <div class="form-control-wrap">
            <v-text
              v-model="update_data.name"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="name"
              placeholder=""
              :disabled="readonly"
            ></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-6 col-md-3">
        <div class="form-group" v-if="field_update_options['email'] && field_update_options['email'].length">
          <div class="tooltip-v2">
            <div v-if="(data.email || update_data.email) && data.email != update_data.email">
              <div class="tooltip-v2-text left" v-html="data.email ? data.email : 'Not filled yet'"></div>
              <label class="form-control-wrap">Email <span class="d-inline text-success visible">*</span></label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Email</label>
            </div>

            <v-select v-model="update_data.email" class="form-control" name="email" :options="field_update_options['email']"></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Email</label>
          <div class="form-control-wrap">
            <v-text
              v-model="update_data.email"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="email"
              placeholder=""
              :disabled="readonly"
            ></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-6 col-md-3">
        <div class="form-group" v-if="field_update_options['phone'] && field_update_options['phone'].length">
          <div class="tooltip-v2">
            <div v-if="(data.phone || update_data.phone) && data.phone != update_data.phone">
              <div class="tooltip-v2-text left" v-html="data.phone ? data.phone : 'Not filled yet'"></div>
              <label class="form-control-wrap">
                Phone <span style="color: #ff1d25;">*</span> <span class="d-inline text-success visible">*</span>
              </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Phone <span style="color: #ff1d25;">*</span></label>
            </div>

            <v-select v-model="update_data.phone" class="form-control" name="phone" :options="field_update_options['phone']"></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Phone <span style="color: #ff1d25;">*</span></label>
          <div class="form-control-wrap">
            <v-phone
              v-model="update_data.phone"
              type="text"
              class="form-control"
              name="phone"
              autocomplete="off"
              placeholder=""
              :disabled="readonly"
            ></v-phone>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-6 col-md-3">
        <div class="form-group" v-if="field_update_options['fax'] && field_update_options['fax'].length">
          <div class="tooltip-v2">
            <div v-if="(data.fax || update_data.fax) && data.fax != update_data.fax">
              <div class="tooltip-v2-text left" v-html="data.fax ? data.fax : 'Not filled yet'"></div>
              <label class="form-control-wrap">Fax <span class="d-inline text-success visible">*</span></label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Fax</label>
            </div>

            <v-select v-model="update_data.fax" class="form-control" name="fax" :options="field_update_options['fax']"></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Fax</label>
          <div class="form-control-wrap">
            <v-text
              v-model="update_data.fax"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="fax"
              placeholder=""
              :disabled="readonly"
            ></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-sm-6 col-md-3">
        <div class="form-group" v-if="field_update_options['address.address'] && field_update_options['address.address'].length">
          <div class="tooltip-v2">
            <div v-if="(data.address.address || update_data.address.address) && data.address.address != update_data.address.address">
              <div class="tooltip-v2-text left" v-html="data.address.address ? data.address.address : 'Not filled yet'"></div>
              <label class="form-control-wrap">
                Address <span style="color: #ff1d25;">*</span> <span class="d-inline text-success visible">*</span>
              </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Address <span style="color: #ff1d25;">*</span></label>
            </div>

            <v-select
              v-model="update_data.address.address"
              class="form-control"
              name="address[address]"
              :options="field_update_options['address.address']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Address <span style="color: #ff1d25;">*</span></label>
          <div class="form-control-wrap">
            <v-text
              v-model="update_data.address.address"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="address[address]"
              placeholder=""
              :disabled="readonly"
            ></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-6 col-md-3">
        <div class="form-group" v-if="field_update_options['address.city'] && field_update_options['address.city'].length">
          <div class="tooltip-v2">
            <div v-if="(data.address.city || update_data.address.city) && data.address.city != update_data.address.city">
              <div class="tooltip-v2-text left" v-html="data.address.city ? data.address.city : 'Not filled yet'"></div>
              <label class="form-control-wrap">
                City <span style="color: #ff1d25;">*</span> <span class="d-inline text-success visible">*</span>
              </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">City <span style="color: #ff1d25;">*</span></label>
            </div>

            <v-select
              v-model="update_data.address.city"
              class="form-control"
              name="address[city]"
              :options="field_update_options['address.city']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">City <span style="color: #ff1d25;">*</span></label>
          <div class="form-control-wrap">
            <v-text
              v-model="update_data.address.city"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="address[city]"
              placeholder=""
              :disabled="readonly"
            ></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-6 col-md-3">
        <div class="form-group" v-if="field_update_options['address.state_id'] && field_update_options['address.state_id'].length">
          <div class="tooltip-v2">
            <div v-if="(data.address.state_id || update_data.address.state_id) && data.address.state_id != update_data.address.state_id">
              <div class="tooltip-v2-text left" v-html="getOptionText(data.address.state_id, 'states') || 'Not filled yet'"></div>
              <label class="form-control-wrap">
                State <span style="color: #ff1d25;">*</span> <span class="d-inline text-success visible">*</span>
              </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">State <span style="color: #ff1d25;">*</span></label>
            </div>

            <v-select
              v-model="update_data.address.state_id"
              class="form-control"
              name="address[state_id]"
              :options="field_update_options['address.state_id']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">State <span style="color: #ff1d25;">*</span></label>
          <v-select
            v-model="update_data.address.state_id"
            class="form-control"
            name="address[state_id]"
            :options="options.states"
            :disabled="readonly"
          ></v-select>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-6 col-md-3">
        <div class="form-group" v-if="field_update_options['address.zip'] && field_update_options['address.zip'].length">
          <div class="tooltip-v2">
            <div v-if="(data.address.zip || update_data.address.zip) && data.address.zip != update_data.address.zip">
              <div class="tooltip-v2-text left" v-html="data.address.zip ? data.address.zip : 'Not filled yet'"></div>
              <label class="form-control-wrap">
                Zip <span style="color: #ff1d25;">*</span> <span class="d-inline text-success visible">*</span>
              </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Zip <span style="color: #ff1d25;">*</span></label>
            </div>

            <v-select
              v-model="update_data.address.zip"
              class="form-control"
              name="address[zip]"
              :options="field_update_options['address.zip']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Zip <span style="color: #ff1d25;">*</span></label>
          <div class="form-control-wrap">
            <v-text
              v-model="update_data.address.zip"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="address[zip]"
              placeholder=""
              :disabled="readonly"
            ></v-text>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-sm-6 col-md-6">
        <div class="form-group" v-if="field_update_options['check_in_time'] && field_update_options['check_in_time'].length">
          <div class="tooltip-v2">
            <div v-if="(data.check_in_time || update_data.check_in_time) && data.check_in_time != update_data.check_in_time">
              <div class="tooltip-v2-text left" v-html="data.check_in_time ? data.check_in_time : 'Not filled yet'"></div>
              <label class="form-control-wrap">
                Check In Time <span style="color: #ff1d25;">*</span> <span class="d-inline text-success visible">*</span>
              </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Check In Time <span style="color: #ff1d25;">*</span></label>
            </div>

            <v-select
              v-model="update_data.check_in_time"
              class="form-control"
              name="check_in_time"
              :options="field_update_options['check_in_time']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Check In Time <span style="color: #ff1d25;">*</span></label>
          <div class="form-control-wrap">
            <v-timepicker
              v-model="update_data.check_in_time"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="check_in_time"
              placeholder=""
              :disabled="readonly"
            ></v-timepicker>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-6 col-md-6">
        <div class="form-group" v-if="field_update_options['check_out_time'] && field_update_options['check_out_time'].length">
          <div class="tooltip-v2">
            <div v-if="(data.check_out_time || update_data.check_out_time) && data.check_out_time != update_data.check_out_time">
              <div class="tooltip-v2-text left" v-html="data.check_out_time ? data.check_out_time : 'Not filled yet'"></div>
              <label class="form-control-wrap">
                Check Out Time <span style="color: #ff1d25;">*</span> <span class="d-inline text-success visible">*</span>
              </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Check Out Time <span style="color: #ff1d25;">*</span></label>
            </div>

            <v-select
              v-model="update_data.check_out_time"
              class="form-control"
              name="check_out_time"
              :options="field_update_options['check_out_time']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Check Out Time <span style="color: #ff1d25;">*</span></label>
          <div class="form-control-wrap">
            <v-timepicker
              v-model="update_data.check_out_time"
              class="form-control alphanumeric-field "
              autocomplete="off"
              name="check_out_time"
              placeholder=""
              :disabled="readonly"
            ></v-timepicker>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-sm-6 col-md-3">
        <div class="form-group" v-if="field_update_options['kitchen'] && field_update_options['kitchen'].length">
          <div class="tooltip-v2">
            <div v-if="(data.kitchen || update_data.kitchen) && data.kitchen != update_data.kitchen">
              <div class="tooltip-v2-text left" v-html="getOptionText(data.kitchen, 'hotel_kitchen') || 'Not filled yet'"></div>
              <label class="form-control-wrap"> Kitchen <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Kitchen</label>
            </div>

            <v-select v-model="update_data.kitchen" class="form-control" name="kitchen" :options="field_update_options['kitchen']"></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Kitchen</label>
          <v-select
            v-model="update_data.kitchen"
            class="form-control"
            name="kitchen"
            :options="options.hotel_kitchen"
            :disabled="readonly"
          ></v-select>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-6 col-md-3">
        <div class="form-group" v-if="field_update_options['breakfast'] && field_update_options['breakfast'].length">
          <div class="tooltip-v2">
            <div v-if="(data.breakfast || update_data.breakfast) && data.breakfast != update_data.breakfast">
              <div class="tooltip-v2-text left" v-html="getOptionText(data.breakfast, 'confirm') || 'Not filled yet'"></div>
              <label class="form-control-wrap">Breakfast Included? <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Breakfast Included?</label>
            </div>

            <v-select v-model="update_data.breakfast" class="form-control" name="breakfast" :options="field_update_options['breakfast']"></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Breakfast Included?</label>
          <v-select v-model="update_data.breakfast" class="form-control" name="breakfast" :options="options.confirm" :disabled="readonly"></v-select>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-6 col-md-6">
        <div class="form-group" v-if="field_update_options['kitchen_notes'] && field_update_options['kitchen_notes'].length">
          <div class="tooltip-v2">
            <div v-if="(data.kitchen_notes || update_data.kitchen_notes) && data.kitchen_notes != update_data.kitchen_notes">
              <div class="tooltip-v2-text left" v-html="data.kitchen_notes ? data.kitchen_notes : 'Not filled yet'"></div>
              <label class="form-control-wrap"> Kitchen Details <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Kitchen Details</label>
            </div>

            <v-select
              v-model="update_data.kitchen_notes"
              class="form-control"
              name="kitchen_notes"
              :options="field_update_options['kitchen_notes']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Kitchen Details</label>
          <div class="form-control-wrap">
            <v-textarea
              v-model="update_data.kitchen_notes"
              class="form-control alphanumeric-field"
              name="kitchen_notes"
              rows="1"
              max-height="100000"
              :disabled="readonly"
              :important="true"
              :autosize="true"
            ></v-textarea>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-sm-6 col-md-3">
        <div class="form-group" v-if="field_update_options['pets'] && field_update_options['pets'].length">
          <div class="tooltip-v2">
            <div v-if="(data.pets || update_data.pets) && data.pets != update_data.pets">
              <div class="tooltip-v2-text left" v-html="getOptionText(data.pets, 'confirm') || 'Not filled yet'"></div>
              <label class="form-control-wrap">Pet Friendly <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Pet Friendly</label>
            </div>

            <v-select v-model="update_data.pets" class="form-control" name="pets" :options="field_update_options['pets']"></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Pet Friendly</label>
          <v-select v-model="update_data.pets" class="form-control" name="pets" :options="options.confirm" :disabled="readonly"></v-select>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-6 col-md-3">
        <div class="form-group" v-if="field_update_options['pet_fee'] && field_update_options['pet_fee'].length">
          <div class="tooltip-v2">
            <div v-if="(data.pet_fee || update_data.pet_fee) && data.pet_fee != update_data.pet_fee">
              <div class="tooltip-v2-text left" v-html="data.pet_fee ? data.pet_fee : 'Not filled yet'"></div>
              <label class="form-control-wrap">Pet Fee <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Pet Fee</label>
            </div>

            <v-select v-model="update_data.pet_fee" class="form-control" name="pet_fee" :options="field_update_options['pet_fee']"></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Pet Fee</label>
          <div class="form-control-wrap form-control-currency">
            <i class="fas fa-dollar-sign"></i>
            <v-currency
              :is-blank="false"
              v-model="update_data.pet_fee"
              v-tooltip="update_data.pet_fee"
              type="text"
              class="form-control"
              name="pet_fee"
              :disabled="readonly"
            >
            </v-currency>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div
        class="col-sm-6 col-md-3"
        v-if="
          (field_update_options['pet_fee_nightly'] && field_update_options['pet_fee_nightly'].length) ||
            (field_update_options['pet_fee_nightly_enabled'] && field_update_options['pet_fee_nightly_enabled'].length)
        "
      >
        <div class="form-group">
          <div class="tooltip-v2">
            <div
              v-if="
                (!data.pet_fee_nightly_enabled && update_data.pet_fee_nightly !== '-') ||
                  (data.pet_fee_nightly_enabled &&
                    (data.pet_fee_nightly || update_data.pet_fee_nightly) &&
                    data.pet_fee_nightly != update_data.pet_fee_nightly)
              "
            >
              <div
                class="tooltip-v2-text left"
                v-html="!data.pet_fee_nightly_enabled ? 'N/A' : data.pet_fee_nightly ? data.pet_fee_nightly : 'Not filled yet'"
              ></div>
              <label class="form-control-wrap">Pet: Nightly Rate <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Pet: Nightly Rate</label>
            </div>

            <v-select
              v-model="update_data.pet_fee_nightly"
              class="form-control"
              name="pet_fee_nightly"
              :options="field_update_options['pet_fee_nightly']"
            ></v-select>
            <v-checkbox
              v-model="update_data.pet_fee_nightly_enabled"
              class="form-check-input"
              name="pet_fee_nightly_enabled"
              :disabled="readonly"
            ></v-checkbox>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col col-sm-4 col-md-3 form-check-text" v-else>
        <div class="form-group">
          <div class="form-check" tabindex="0">
            <v-checkbox
              v-model="update_data.pet_fee_nightly_enabled"
              class="form-check-input"
              name="pet_fee_nightly_enabled"
              :disabled="readonly"
            ></v-checkbox>
            <label class="form-check-label">
              <div class="form-check-label-inner">Pet: Nightly Rate</div>
              <span class="form-check-custom flex-row-reverse">
                <small v-if="!update_data.pet_fee_nightly_enabled" class="ml-2">N/A</small>
              </span>
            </label>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-if="update_data.pet_fee_nightly_enabled">
          <label class="form-control-wrap">Pet: Nightly Rate</label>
          <div class="form-control-wrap form-control-currency">
            <i class="fas fa-dollar-sign"></i>

            <v-currency
              :is-blank="false"
              v-model="update_data.pet_fee_nightly"
              v-tooltip="update_data.pet_fee_nightly"
              type="text"
              class="form-control"
              name="pet_fee_nightly"
              :disabled="readonly"
            >
            </v-currency>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-6 col-md-3">
        <div class="form-group" v-if="field_update_options['pet_details'] && field_update_options['pet_details'].length">
          <div class="tooltip-v2">
            <div v-if="(data.pet_details || update_data.pet_details) && data.pet_details != update_data.pet_details">
              <div class="tooltip-v2-text left" v-html="data.pet_details ? data.pet_details : 'Not filled yet'"></div>
              <label class="form-control-wrap"> Pet Details <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Pet Details</label>
            </div>

            <v-select
              v-model="update_data.pet_details"
              class="form-control"
              name="pet_details"
              :options="field_update_options['pet_details']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Pet Details</label>
          <div class="form-control-wrap">
            <v-textarea
              v-model="update_data.pet_details"
              class="form-control alphanumeric-field"
              name="pet_details"
              rows="1"
              max-height="100000"
              :disabled="readonly"
              :important="true"
              :autosize="true"
            ></v-textarea>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div
        class="col-sm-6 col-md-3"
        v-if="
          (field_update_options['parking_fee_valet'] && field_update_options['parking_fee_valet'].length) ||
            (field_update_options['parking_fee_valet_enabled'] && field_update_options['parking_fee_valet_enabled'].length)
        "
      >
        <div class="form-group">
          <div class="tooltip-v2">
            <div
              v-if="
                (!data.parking_fee_valet_enabled && update_data.parking_fee_valet !== '-') ||
                  (data.parking_fee_valet_enabled &&
                    (data.parking_fee_valet || update_data.parking_fee_valet) &&
                    data.parking_fee_valet != update_data.parking_fee_valet)
              "
            >
              <div
                class="tooltip-v2-text left"
                v-html="!data.parking_fee_valet_enabled ? 'N/A' : data.parking_fee_valet ? data.parking_fee_valet : 'Not filled yet'"
              ></div>
              <label class="form-control-wrap">Valet Parking Rate <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Valet Parking Rate</label>
            </div>

            <v-select
              v-model="update_data.parking_fee_valet"
              class="form-control"
              name="parking_fee_valet"
              :options="field_update_options['parking_fee_valet']"
            ></v-select>
            <v-checkbox
              v-model="update_data.parking_fee_valet_enabled"
              class="form-check-input"
              name="parking_fee_valet_enabled"
              :disabled="readonly"
            ></v-checkbox>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col col-sm-4 col-md-3 form-check-text" v-else>
        <div class="form-group">
          <div class="form-check" tabindex="0">
            <v-checkbox
              v-model="update_data.parking_fee_valet_enabled"
              class="form-check-input"
              name="parking_fee_valet_enabled"
              :disabled="readonly"
            ></v-checkbox>
            <label class="form-check-label">
              <div class="form-check-label-inner">Valet Parking Rate</div>
              <span class="form-check-custom flex-row-reverse">
                <small v-if="!update_data.parking_fee_valet_enabled" class="ml-2">N/A</small>
              </span>
            </label>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-if="update_data.parking_fee_valet_enabled">
          <label class="form-control-wrap">Valet Parking Rate</label>
          <div class="form-control-wrap form-control-currency">
            <i class="fas fa-dollar-sign"></i>

            <v-currency
              :is-blank="false"
              v-model="update_data.parking_fee_valet"
              v-tooltip="update_data.parking_fee_valet"
              type="text"
              class="form-control"
              name="parking_fee_valet"
              :disabled="readonly"
            >
            </v-currency>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div
        class="col-sm-6 col-md-3"
        v-if="
          (field_update_options['parking_fee'] && field_update_options['parking_fee'].length) ||
            (field_update_options['parking_fee_enabled'] && field_update_options['parking_fee_enabled'].length)
        "
      >
        <div class="form-group">
          <div class="tooltip-v2">
            <div
              v-if="
                (!data.parking_fee_enabled && update_data.parking_fee !== '-') ||
                  (data.parking_fee_enabled && (data.parking_fee || update_data.parking_fee) && data.parking_fee != update_data.parking_fee)
              "
            >
              <div
                class="tooltip-v2-text left"
                v-html="!data.parking_fee_enabled ? 'N/A' : data.parking_fee ? data.parking_fee : 'Not filled yet'"
              ></div>
              <label class="form-control-wrap">Self Parking Rate <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Self Parking Rate</label>
            </div>

            <v-select
              v-model="update_data.parking_fee"
              class="form-control"
              name="parking_fee"
              :options="field_update_options['parking_fee']"
            ></v-select>
            <v-checkbox
              v-model="update_data.parking_fee_enabled"
              class="form-check-input"
              name="parking_fee_enabled"
              :disabled="readonly"
            ></v-checkbox>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col col-sm-4 col-md-3 form-check-text" v-else>
        <div class="form-group">
          <div class="form-check" tabindex="0">
            <v-checkbox
              v-model="update_data.parking_fee_enabled"
              class="form-check-input"
              name="parking_fee_enabled"
              :disabled="readonly"
            ></v-checkbox>
            <label class="form-check-label">
              <div class="form-check-label-inner">Self Parking Rate</div>
              <span class="form-check-custom flex-row-reverse">
                <small v-if="!update_data.parking_fee_enabled" class="ml-2">N/A</small>
              </span>
            </label>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-if="update_data.parking_fee_enabled">
          <label class="form-control-wrap">Self Parking Rate</label>
          <div class="form-control-wrap form-control-currency">
            <i class="fas fa-dollar-sign"></i>

            <v-currency
              :is-blank="false"
              v-model="update_data.parking_fee"
              v-tooltip="update_data.parking_fee"
              type="text"
              class="form-control"
              name="parking_fee"
              :disabled="readonly"
            >
            </v-currency>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>

      <div class="col-sm-6 col-md-6">
        <div class="form-group" v-if="field_update_options['certifi_required'] && field_update_options['certifi_required'].length">
          <div class="tooltip-v2">
            <div v-if="(data.certifi_required || update_data.certifi_required) && data.certifi_required != update_data.certifi_required">
              <div class="tooltip-v2-text left" v-html="getOptionText(data.certifi_required, 'confirm') || 'Not filled yet'"></div>
              <label class="form-control-wrap">Certifi Form Required <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Certifi Form Required</label>
            </div>

            <v-select
              v-model="update_data.certifi_required"
              class="form-control"
              name="certifi_required"
              :options="field_update_options['certifi_required']"
            ></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Certifi Form Required</label>
          <v-select
            v-model="update_data.certifi_required"
            class="form-control"
            name="certifi_required"
            :options="options.confirm"
            :disabled="readonly"
          ></v-select>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="col-sm-6 col-md-6">
        <div class="form-group" v-if="field_update_options['info'] && field_update_options['info'].length">
          <div class="tooltip-v2">
            <div v-if="(data.info || update_data.info) && data.info != update_data.info">
              <div class="tooltip-v2-text left" v-html="data.info ? data.info : 'Not filled yet'"></div>
              <label class="form-control-wrap"> Misc Info <span class="d-inline text-success visible">*</span> </label>
            </div>
            <div v-else>
              <label class="form-control-wrap">Misc Info</label>
            </div>

            <v-select v-model="update_data.info" class="form-control" name="info" :options="field_update_options['info']"></v-select>
          </div>
          <small id="" class="form-text text-danger">Value is invalid.</small>
        </div>
        <div class="form-group" v-else>
          <label class="form-control-wrap">Misc Info</label>
          <div class="form-control-wrap">
            <v-textarea
              v-model="update_data.info"
              class="form-control alphanumeric-field"
              name="info"
              rows="2"
              max-height="100000"
              :disabled="readonly"
              :important="true"
              :autosize="true"
            ></v-textarea>
          </div>
          <small class="form-text text-danger">Value is invalid.</small>
        </div>
      </div>
    </div>

    <div class="my-2" v-if="!readonly">
      (<span style="color: #ff1d25;">*</span>) is required fields<br />
      (<span class="text-success">*</span>) is updated fields
    </div>

    <input type="hidden" name="hotel_id" v-model="hotel_id" />
  </form>
</template>

<script>
export default {
  props: ["hotel_id", "data", "update_requests", "options", "readonly"],
  data() {
    return {
      update_data: { ...JSON.parse(JSON.stringify(this.data)) },
      field_update_options: {},
      watch_keys: [
        "name",
        "email",
        "phone",
        "fax",
        "address.address",
        "address.city",
        "address.state_id",
        "address.zip",
        "check_in_time",
        "check_out_time",
        "kitchen",
        "breakfast",
        "certifi_required",
        "pets",
        "pet_fee",
        "pet_fee_nightly",
        "pet_fee_nightly_enabled",
        "pet_details",
        "parking_fee_valet",
        "parking_fee_valet_enabled",
        "parking_fee",
        "parking_fee_enabled",
        "kitchen_notes",
        "info"
      ]
    };
  },
  computed: {
    isNew() {
      return this.data.created_at === this.data.updated_at;
    }
  },
  watch: {
    "update_data.pet_fee_nightly": {
      handler(value) {
        this.update_data.pet_fee_nightly_enabled = value !== "-";
      }
    },
    "update_data.parking_fee": {
      handler(value) {
        this.update_data.parking_fee_enabled = value !== "-";
      }
    },
    "update_data.parking_fee_valet": {
      handler(value) {
        this.update_data.parking_fee_valet_enabled = value !== "-";
      }
    }
  },
  methods: {
    getOptionText(id, key) {
      const option = this.options[key].find(s => s.id == id);
      return option ? option.text : "";
    },
    updateKey(obj, field, value) {
      let keys = field.split(".");
      keys.reduce((acc, key, index) => {
        if (index === keys.length - 1) acc[key] = value;
        return acc[key];
      }, obj);
    },
    formatDate(date) {
      return moment(date)
        .local()
        .format("MM/DD/YYYY hh:mm:ss A");
    },
    getOptions(field) {
      const ids = { [field]: new Set() };
      const matchText = this.hotel_id ? "[Match]" : "[Original]";
      let masterField = field.split(".").reduce((o, i) => o[i], this.data);

      const options = this.update_requests.reduce((acc, update_request) => {
        let updateField = field.split(".").reduce((o, i) => o[i], update_request.data);
        const isChanged = (updateField !== null || updateField !== undefined) && updateField != masterField && (updateField || masterField);
        const fieldHasToggle = ["pet_fee_nightly", "parking_fee", "parking_fee_valet"].includes(field);

        if (!isChanged && !fieldHasToggle) return acc;

        masterField = typeof masterField === "string" ? masterField.replace(/'/g, "’") : masterField;
        updateField = typeof updateField === "string" ? updateField.replace(/'/g, "’") : updateField;

        const source = update_request.source && update_request.source.policyholder ? ` - [${update_request.source.policyholder.name}]` : "";
        const updateTime = moment(update_request.updated_at)
          .local()
          .format("MM/DD/YYYY hh:mm:ss A");
        const updateDetails = `[${update_request.changed_by}]${source} - [${updateTime}]`;

        const original = { id: masterField || "", text: `${masterField || ""} - ${matchText}` };
        const option = { id: updateField || "", text: `${updateField || ""} - ${updateDetails}` };

        if (["kitchen", "breakfast", "certifi_required", "pets"].includes(field)) {
          const masterBoolVal = this.options[field === "kitchen" ? "hotel_kitchen" : "confirm"].find(i => i.id == masterField);
          const boolVal = this.options[field === "kitchen" ? "hotel_kitchen" : "confirm"].find(i => i.id == updateField);

          if (masterBoolVal) original.text = `${masterBoolVal.text || ""} - ${matchText}`;
          if (boolVal) option.text = `${boolVal.text || ""} - ${updateDetails}`;
        } else if ("pet_fee" === field) {
          const masterFloat = parseFloat(masterField || 0).toFixed(2);
          const updateFloat = parseFloat(updateField || 0).toFixed(2);

          if (masterFloat === updateFloat) return acc;

          original.text = `$${masterFloat} - ${matchText}`;
          option.text = `$${updateFloat} - ${updateDetails}`;
        } else if (["pet_fee_nightly", "parking_fee", "parking_fee_valet"].includes(field)) {
          const enabledField = `${field}_enabled`;
          const masterFloat = parseFloat(masterField || 0).toFixed(2);
          const updateFloat = parseFloat(updateField || 0).toFixed(2);
          const masterToggle = this.data[enabledField] == true;
          const updateToggle = update_request.data[enabledField] == true;

          if (masterFloat === updateFloat && masterToggle === updateToggle) return acc;

          original.text = `$${masterFloat} - ${matchText}`;
          option.text = `$${updateFloat} - ${updateDetails}`;

          if (!masterToggle && updateToggle) {
            original.id = "-";
            original.text = `N/A - ${matchText}`;
          } else if (masterToggle && !updateToggle) {
            option.id = "-";
            option.text = `N/A - ${updateDetails}`;
            updateField = "-";
          }
        } else if (["pet_fee_nightly_enabled", "parking_fee_enabled", "parking_fee_valet_enabled"].includes(field)) {
          masterField = this.data[field] == true;
          updateField = update_request.data[field] == true;

          original.id = masterField;
          original.text = `${masterField} - ${matchText}`;

          option.id = updateField;
          option.text = `${updateField} - ${updateDetails}`;
        } else if (field === "address.state_id") {
          const masterStateVal = this.options.states.find(i => i.id == masterField);
          const stateVal = this.options.states.find(i => i.id == updateField);
          if (masterStateVal) {
            original.text = `${masterStateVal.text || ""} - ${matchText}`;
          }
          if (stateVal) {
            option.text = `${stateVal.text || ""} - ${updateDetails}`;
          }
        }

        if (!acc.length) {
          if (field === "address.state_id") {
            acc = [...this.options.states];
          }

          acc.push(original);
          ids[field].add(original.id);
        }

        if (!ids[field].has(option.id)) {
          acc.push(option);
          ids[field].add(option.id);
        }

        if (!this.hotel_id) {
          this.updateKey(this.update_data, field, updateField);
        }

        return acc;
      }, []);

      return options;
    }
  },
  mounted() {
    const options = new Map();
    this.watch_keys.map(field => options.set(field, this.getOptions(field)));
    this.field_update_options = Object.fromEntries(options);
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/alerts/hotel-approval.vue